import { useEffect, useState } from "react";
import {
  FaLine,
  FaRegCheckCircle,
  FaRegClock,
  FaRegFrown,
  FaRegMeh,
  FaRegSmile,
  FaRegTimesCircle,
  FaSnapchatSquare,
  FaTelegramPlane,
} from "react-icons/fa";
import { MdOutlineCellTower } from "react-icons/md";
import { FiMinusCircle } from "react-icons/fi";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Scrollbar } from "swiper/modules";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { API_URL, API_URL_PAYMENT } from "../../../utilities/url";
import storage from "../../../services/storage";
import CryptoJS from "crypto-js";
import { format_number } from "../../../utilities/ext-function";
import { IoLogoWhatsapp } from "react-icons/io";
import ModalReport from "./reportAnayzeModal";
import authService from "../../../services/auth.service";

export default function BroadcastChart() {
  const location = useLocation();
  const decryptUSR = CryptoJS.AES.decrypt(storage.get("user"), "user").toString(
    CryptoJS.enc.Utf8
  );
  const usr = JSON.parse(decryptUSR);
  const decryptWS = CryptoJS.AES.decrypt(storage.get("wrs"), "wrs").toString(
    CryptoJS.enc.Utf8
  );
  const workspace = JSON.parse(decryptWS);
  const [loading, setLoading] = useState(true);
  const [dataBroadcast, setDataBroadcast] = useState([]);
  const [dataBroadcastGraf, setDataBroadcastGraf] = useState([]);
  const [dataChatbotGraf, setDataChatbotGraf] = useState([]);
  const [modalReport, setModalReport] = useState(false);
  const [selectedReport, setSelectedReport] = useState(false);
  const currentYear = new Date().getFullYear();
  const lastThreeYears = Array.from({ length: 3 }, (_, i) => currentYear - i);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const handleChangeYear = (e) => {
    setSelectedYear(e.target.value);
  };

  const getChannelIcon = (channel) => {
    switch (channel.toLowerCase()) {
      case "whatsapp":
        return (
          <IoLogoWhatsapp
            style={{ color: "#25D366", marginTop: "-2px" }}
            size={18}
          />
        );
      case "telegram":
        return <FaTelegramPlane style={{ color: "#0088cc" }} size={16} />;
      case "line":
        return <FaLine style={{ color: "#00C300" }} size={16} />;
      case "snapchat":
        return <FaSnapchatSquare style={{ color: "#FFFC00" }} size={16} />;
      default:
        return null;
    }
  };

  const getChannelColor = (channel) => {
    switch (channel.toLowerCase()) {
      case "whatsapp":
        return "#25D366"; // Hijau WhatsApp
      case "telegram":
        return "#0088cc"; // Biru Telegram
      case "line":
        return "#00C300"; // Hijau Line
      case "snapchat":
        return "#FFFC00"; // Kuning Snapchat
      default:
        return "#6B7280"; // Default abu-abu
    }
  };

  const colors = ["#00c49f", "#fb8500", "#fc003b", "#aaa", "#0088fe"];

  const data3 = [
    { name: "Completed", value: 40 }, // Nilai progress
    { name: "Remaining", value: 100 - 40 }, // Sisa dari progress
  ];

  const colors2 = ["#fb8500", "#fee7cf"];

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getDataBroadcast();
    getDataBroadcastGraf();
    getDataChatbotSentimentGraf();
  }, [location.key, selectedYear]);

  const getDataBroadcast = () => {
    axios
      .post(
        `${API_URL}get-list-broadcast-message`,
        {
          idt_user_workspace: workspace.idt_user_workspace,
        },
        {
          headers: {
            Authorization: `Bearer ${storage.get("access_token")}`,
          },
        }
      )
      .then((response) => {
        if (response.data.success === true) {
          if (response.data.data) {
            setLoading(false);
            setDataBroadcast(response.data.data);
          } else {
            setLoading(false);
            setDataBroadcast([]);
          }
        } else {
          setLoading(false);
          setDataBroadcast([]);
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  const getDataBroadcastGraf = () => {
    axios
      .get(API_URL_PAYMENT + "dashboard/bc/status/send", {
        params: {
          year: selectedYear,
        },
        headers: {
          "X-User-ID": usr.idt_user,
          "X-Workspace-ID": workspace.idt_user_workspace,
        },
      })
      .then((response) => {
        if (response.data.errorcode === "0000") {
          setLoading(false);
          setDataBroadcastGraf(response.data.data);
        } else {
          setLoading(false);
          setDataBroadcastGraf([]);
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  const getDataChatbotSentimentGraf = () => {
    axios
      .get(API_URL_PAYMENT + "dashboard/bc/status/responsesentiment", {
        params: {
          year: selectedYear,
        },
        headers: {
          "X-User-ID": usr.idt_user,
          "X-Workspace-ID": workspace.idt_user_workspace,
        },
      })
      .then((res) => {
        if (res.data.errorcode === "0000") {
          setLoading(false);
          const data = [
            { name: "Positive", value: res.data.data.ws_sentiment_positive },
            { name: "Neutral", value: res.data.data.ws_sentiment_neutral },
            { name: "Negative", value: res.data.data.ws_sentiment_negative },
            { name: "Need Follow Up", value: res.data.data.ws_need_followup },
            { name: "No Response", value: res.data.data.ws_no_response },
          ];
          console.log(data);
          setDataChatbotGraf(data);
        } else {
          setLoading(false);
          setDataChatbotGraf([]);
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  const showReport = (data) => {
    axios
      .post(
        API_URL + "get-broadcast",
        {
          idt_user_workspace: workspace.idt_user_workspace,
          idt_broadcast_campaign: data,
        },
        {
          headers: { Authorization: `Bearer ${storage.get("access_token")}` },
        }
      )
      .then((response) => {
        if (response.data.success) {
          setSelectedReport(response.data.data);
          setModalReport(true);
        } else {
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  return (
    <div className="row">
      <div className="col-lg-4">
        <div className="card rounded-4 shadow-lg">
          <div className="card-header rounded-4">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="icon-panel-circle bg-primary-2 me-3">
                  <MdOutlineCellTower size={18} />
                </div>
                <div className="mt-1">
                  <h4 className="mb-1 fs-16">
                    {dataBroadcast.length} Running Broadcast
                  </h4>
                  {/* <h4 className="mb-0 fs-18">3000 / 4000</h4> */}
                </div>
              </div>
              {/* <div className="text-end">dada</div> */}
            </div>
            <hr className="separator-grey" />
          </div>
          <div className="card-body rounded-4 header-chart">
            <div className="py-3 px-3">
              {dataBroadcast.length > 0 ? (
                <Swiper
                  modules={[Navigation, Pagination, Scrollbar]} // Aktifkan modul Swiper
                  spaceBetween={10} // Jarak antar slide
                  slidesPerView={1} // Berapa slide yang ditampilkan dalam satu waktu
                  // navigation // Aktifkan tombol navigasi
                  pagination={{ clickable: true }} // Aktifkan pagination dengan klik
                  loop={true} // Aktifkan efek loop
                >
                  {dataBroadcast.map((item, index) => (
                    <SwiperSlide key={index} style={{ cursor: "default" }}>
                      <div className="mb-4">
                        <div className="d-flex justify-centent-between">
                          <div className="flex-grow-1">
                            <p className="fs-18 fw-bold text-primary-2 mb-0">
                              {item.name}
                            </p>
                            <p
                              className="fs-16 fw-bold mb-0 flex items-center gap-2"
                              style={{ color: getChannelColor(item.channel) }}
                            >
                              {getChannelIcon(item.channel)} {item.channel}
                            </p>
                            <p className="fw-bold text-primary-2 mb-0">
                              Active Until{" "}
                              {moment(item.end_date).format("DD MMM YYYY")}
                            </p>
                          </div>
                          <div>
                            {/* <p className="fs-26 fw-bold text-primary-2 mb-0">
                              {item.value}
                            </p> */}
                          </div>
                        </div>
                        <div className="d-flex gap-2 mt-2 mb-3">
                          <div className="flex-fill">
                            <div className="border border-2 rounded-3 p-2 fw-bold">
                              <p className="text-warning mb-0">Sent</p>
                              <p className="mb-0">{format_number(item.sent)}</p>
                              <p className="mb-0">Contact</p>
                            </div>
                          </div>
                          <div className="flex-fill">
                            <div className="border border-2 rounded-3 p-2 fw-bold">
                              <p className="text-info mb-0">Delivered</p>
                              <p className="mb-0">
                                {format_number(item.delivered)}
                              </p>
                              <p className="mb-0">Contact</p>
                            </div>
                          </div>
                          <div className="flex-fill">
                            <div className="border border-2 rounded-3 p-2 fw-bold">
                              <p className="text-success mb-0">Read</p>
                              <p className="mb-0">
                                {format_number(item.read_count)}
                              </p>
                              <p className="mb-0">Contact</p>
                            </div>
                          </div>
                          <div className="flex-fill">
                            <div className="border border-2 rounded-3 p-2 fw-bold">
                              <p className="text-danger mb-0">Failed</p>
                              <p className="mb-0">
                                {format_number(item.failed)}
                              </p>
                              <p className="mb-0">Contact</p>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12 mb-3">
                          <div className="mb-3 text-center">
                            <a
                              onClick={() =>
                                showReport(item.idt_broadcast_campaign)
                              }
                              class="btn btm-sm btn-orange"
                            >
                              <span>View More</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : loading ? (
                <div className="mb-4">
                  <div className="d-flex align-items-start">
                    <div className="flex-grow-1">
                      <Skeleton height={30} className="mb-1" />
                      <Skeleton height={20} className="mb-0" />
                      <Skeleton height={20} className="mb-0" />
                    </div>
                  </div>
                  <div className="w-100">
                    <Skeleton height={120} className="mb-2" />
                  </div>
                </div>
              ) : (
                <div className="mb-4">
                  <div className="text-center" style={{ height: "180px" }}>
                    <p className="fs-18">No active broadcast</p>
                    <p className="fs-24 fw-bold">Let’s fix that.</p>
                    <p className="fs-24 fw-bold">
                      "Create Broadcast" now and reach your audiences better.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="card-footer rounded-4">
            <hr className="separator-grey" />
            <div class="col-md-12">
              <Link to="/broadcast/add" class="btn btn-lg btn-primary w-100">
                <MdOutlineCellTower size={24} className="me-2" />
                <span>Create Broadcast</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="col-8">
        <div className="card rounded-4 shadow-lg">
          <div className="card-header rounded-4 header-chart">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5 className="card-title mb-0">Finished Broadcast</h5>
                <p className="text-dark fw-bold mb-0">Total 5000 Contact</p>
              </div>
              <div className="d-flex align-items-center">
                <span className="me-2" style={{ width: "100px" }}>
                  Filter Period:
                </span>
                <select
                  className="form-select me-2"
                  style={{ width: "100px" }}
                  value={selectedYear} // Menghubungkan state ke dropdown
                  onChange={handleChangeYear} // Menjalankan fungsi saat ada perubahan
                >
                  {lastThreeYears.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
                {/* <select
                  className="form-select"
                  style={{ width: "150px" }}
                  aria-label="Filter Periode 2"
                >
                  <option value="">All</option>
                  <option value="periode1">January</option>
                  <option value="periode2">February</option>
                </select> */}
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="card rounded-4 border-soft-grey">
              <div className="card-body">
                <div className="row">
                  {/* Bagian untuk BroadcastChart dan list di satu baris */}
                  <div className="col-lg-7 d-lg-flex">
                    {/* BroadcastChart di sebelah kiri */}
                    <div className="col-lg-9">
                      <h5>Trend Broadcast</h5>
                      <div className="p-1">
                        {/* {dataBroadcastGraf} */}
                        {dataBroadcastGraf.length > 0 && (
                          <ResponsiveContainer
                            width="100%"
                            height={247}
                            style={{ marginLeft: "-25px" }}
                          >
                            <LineChart data={dataBroadcastGraf}>
                              {/* <CartesianGrid strokeDasharray="3 3" /> */}
                              <XAxis
                                dataKey="month"
                                tick={{
                                  fontSize: 10,
                                  fontWeight: "500",
                                  fill: "#333",
                                }}
                              />
                              <YAxis
                                tick={{
                                  fontSize: 10,
                                  fontWeight: "500",
                                  fill: "#333",
                                }}
                              />
                              <Tooltip contentStyle={{ color: "black" }} />
                              {/* <Legend /> */}
                              <Line
                                type="monotone"
                                dataKey="executed"
                                stroke="#fb8500"
                                activeDot={{ r: 4 }}
                              />
                              <Line
                                type="monotone"
                                dataKey="sent"
                                stroke="#828282"
                                activeDot={{ r: 4 }}
                              />
                              <Line
                                type="monotone"
                                dataKey="delivered"
                                stroke="#0088fe"
                                activeDot={{ r: 4 }}
                              />
                              <Line
                                type="monotone"
                                dataKey="read"
                                stroke="#00c49f"
                                activeDot={{ r: 4 }}
                              />
                              <Line
                                type="monotone"
                                dataKey="failed"
                                stroke="#fc003b"
                                activeDot={{ r: 4 }}
                              />
                            </LineChart>
                          </ResponsiveContainer>
                        )}
                      </div>
                    </div>
                    {/* List Sukses, Invalid, Gagal di sebelah kanan dengan responsive height */}
                    <div className="col-lg-3 d-flex flex-column justify-content-between">
                      <div
                        className="border rounded-3 border-soft-grey p-2 mb-2 d-flex flex-column justify-content-center h-100"
                        style={{
                          backgroundColor: "white",
                          padding: "5px",
                          boxSizing: "border-box",
                        }}
                      >
                        <div className="d-flex align-items-center overflow-hidden">
                          <div className="me-2">
                            <FaRegClock size={20} color="#fb8500" />
                          </div>
                          <div>
                            <h5 className="mb-1 text-nowrap fs-11">Executed</h5>
                            <p
                              className="text-dark fs-10 mb-0 text-truncate"
                              style={{ margin: 0 }}
                            >
                              {format_number(
                                dataBroadcastGraf.reduce(
                                  (sum, item) => sum + item.executed,
                                  0
                                )
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="border rounded-3 border-soft-grey p-2 mb-2 d-flex flex-column justify-content-center h-100"
                        style={{
                          backgroundColor: "white",
                          padding: "5px",
                          boxSizing: "border-box",
                        }}
                      >
                        <div className="d-flex align-items-center overflow-hidden">
                          <div className="me-2">
                            <FaRegCheckCircle size={20} color="#aaa" />
                          </div>
                          <div>
                            <h5 className="mb-1 text-nowrap fs-11">Sent</h5>
                            <p
                              className="text-dark fs-10 mb-0 text-truncate"
                              style={{ margin: 0 }}
                            >
                              {format_number(
                                dataBroadcastGraf.reduce(
                                  (sum, item) => sum + item.sent,
                                  0
                                )
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="border rounded-3 border-soft-grey p-2 mb-2 d-flex flex-column justify-content-center h-100"
                        style={{
                          backgroundColor: "white",
                          padding: "5px",
                          boxSizing: "border-box",
                        }}
                      >
                        <div className="d-flex align-items-center overflow-hidden">
                          <div className="me-2">
                            <FaRegCheckCircle size={20} color="#0088fe" />
                          </div>
                          <div>
                            <h5 className="mb-1 text-nowrap fs-11">
                              Delivered
                            </h5>
                            <p
                              className="text-dark fs-10 mb-0 text-truncate"
                              style={{ margin: 0 }}
                            >
                              {format_number(
                                dataBroadcastGraf.reduce(
                                  (sum, item) => sum + item.delivered,
                                  0
                                )
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="border rounded-3 border-soft-grey p-2 mb-2 d-flex flex-column justify-content-center h-100"
                        style={{
                          backgroundColor: "white",
                          padding: "10px",
                          boxSizing: "border-box",
                        }}
                      >
                        <div className="d-flex align-items-center overflow-hidden">
                          <div className="me-2">
                            <FaRegCheckCircle size={20} color="#00c49f" />
                          </div>
                          <div>
                            <h5 className="mb-1 text-nowrap fs-11">Read</h5>
                            <p
                              className="text-dark fs-10 mb-0 text-truncate"
                              style={{ margin: 0 }}
                            >
                              {format_number(
                                dataBroadcastGraf.reduce(
                                  (sum, item) => sum + item.read,
                                  0
                                )
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="border rounded-3 border-soft-grey p-2 d-flex flex-column justify-content-center h-100"
                        style={{
                          backgroundColor: "white",
                          padding: "10px",
                          boxSizing: "border-box",
                        }}
                      >
                        <div className="d-flex align-items-center overflow-hidden">
                          <div className="me-2">
                            <FaRegTimesCircle size={20} color="#fc003b" />
                          </div>
                          <div>
                            <h5 className="mb-1 text-nowrap fs-11">Failed</h5>
                            <p
                              className="text-dark fs-10 mb-0 text-truncate"
                              style={{ margin: 0 }}
                            >
                              {format_number(
                                dataBroadcastGraf.reduce(
                                  (sum, item) => sum + item.failed,
                                  0
                                )
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      windowWidth >= 768
                        ? "col-lg-5 d-lg-flex"
                        : "col-lg-5 mt-5"
                    }
                  >
                    <div className="col-lg-8">
                      <h5>Target Responses</h5>
                      <div className="p-3">
                        {dataChatbotGraf.length > 0 && (
                          <ResponsiveContainer width="100%" height={200}>
                            <PieChart>
                              <Pie
                                data={dataChatbotGraf.filter(
                                  (item) => item.name !== "Need Follow Up"
                                )}
                                cx="50%"
                                cy="50%"
                                outerRadius={80}
                                fill="#8884d8"
                                dataKey="value"
                                // label
                              >
                                {dataChatbotGraf
                                  .filter(
                                    (item) => item.name !== "Need Follow Up"
                                  )
                                  .map((entry, index) => (
                                    <Cell
                                      key={`cell-${index}`}
                                      fill={colors[index % colors.length]}
                                    />
                                  ))}
                              </Pie>
                              <Tooltip />
                            </PieChart>
                          </ResponsiveContainer>
                        )}
                      </div>
                    </div>
                    {/* List Sukses, Invalid, Gagal di sebelah kanan dengan responsive height */}
                    <div className="col-lg-4 d-flex flex-column justify-content-between">
                      <div className="border rounded-3 border-soft-grey p-2 mb-2 d-flex flex-column justify-content-center h-100">
                        <div className="d-flex overflow-hidden">
                          <div className="me-2">
                            <FaRegSmile size={20} color="#00c49f" />
                          </div>
                          <div>
                            <h5 className="mb-1 text-nowrap fs-11">Positive</h5>
                            <p className="text-dark fw-bold fs-10 mb-0">
                              {format_number(
                                dataChatbotGraf?.find(
                                  (item) => item.name === "Positive"
                                )?.value || 0
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="border rounded-3 border-soft-grey p-2 mb-2 d-flex flex-column justify-content-center h-100">
                        <div className="d-flex overflow-hidden">
                          <div className="me-2">
                            <FaRegMeh size={20} color="#fb8500" />
                          </div>
                          <div>
                            <h5 className="mb-1 text-nowrap fs-11">Neutral</h5>
                            <p className="text-dark fw-bold fs-10 mb-0">
                              {format_number(
                                dataChatbotGraf?.find(
                                  (item) => item.name === "Neutral"
                                )?.value || 0
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="border rounded-3 border-soft-grey p-2 mb-2 d-flex d-flex flex-column justify-content-center h-100">
                        <div className="d-flex overflow-hidden">
                          <div className="me-2">
                            <FaRegFrown size={20} color="#fc003b" />
                          </div>
                          <div>
                            <h5 className="mb-1 text-nowrap fs-11">Negative</h5>
                            <p className="text-dark fw-bold fs-10 mb-0">
                              {format_number(
                                dataChatbotGraf?.find(
                                  (item) => item.name === "Negative"
                                )?.value || 0
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="border rounded-3 border-soft-grey p-2 mb-2 d-flex d-flex flex-column justify-content-center h-100">
                        <div className="d-flex overflow-hidden">
                          <div className="me-2">
                            <FiMinusCircle size={20} color="#aaa" />
                          </div>
                          <div>
                            <h5 className="mb-1 text-nowrap fs-11">
                              No Response
                            </h5>
                            <p className="text-dark fw-bold fs-10 mb-0">
                              {format_number(
                                dataChatbotGraf?.find(
                                  (item) => item.name === "No Response"
                                )?.value || 0
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="border rounded-3 border-soft-grey p-2 d-flex d-flex flex-column justify-content-center h-100">
                        <div className="d-flex overflow-hidden">
                          <div className="me-2">
                            <FaRegCheckCircle size={20} color="#0088fe" />
                          </div>
                          <div>
                            <h5 className="mb-1 text-nowrap fs-11">
                              Follow Up
                            </h5>
                            <p className="text-dark fw-bold fs-10 mb-0">
                              {format_number(
                                dataChatbotGraf?.find(
                                  (item) => item.name === "Need Follow Up"
                                )?.value || 0
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalReport
        show={modalReport}
        handleClose={() => setModalReport(false)}
        type={null}
        data={selectedReport}
        onDeleteChange={null}
      />
    </div>
  );
}
